import { SortingDirection } from './constants';

export const switchDirection = (direction: SortingDirection) => {
  switch (direction) {
    case SortingDirection.NONE:
      return SortingDirection.ASC;
    case SortingDirection.ASC:
      return SortingDirection.DESC;
    default:
      return SortingDirection.NONE;
  }
};
